module.exports = __webpack_public_path__ + "static/screenshot_timesheets-18f3cdfb95e3691762b1b5529b97e482.png";